import React from 'react';

const FORMS_URL = "https://forms.gle/n5o3Ld3dCXix5Nqd7";

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-600">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-3xl font-bold text-white mb-3">
          Chcete školení AI pro pedagogy vaší školy?
        </h2>
        <p className="text-teal-100 text-lg mb-10 leading-relaxed">
          Rádi vám připravíme školení přizpůsobené vašemu pedagogickému týmu.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
          <a
            href={FORMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-info-btn"
            className="px-8 py-4 bg-white hover:bg-teal-50 text-teal-700 font-semibold rounded-lg text-lg transition-all shadow-lg"
          >
            Chci víc informací
          </a>
          <a
            href={FORMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-register-btn"
            className="px-8 py-4 bg-teal-800 hover:bg-teal-900 text-white font-semibold rounded-lg text-lg transition-all shadow-lg border border-teal-500"
          >
            Nezávazně poptat školení
          </a>
        </div>
        <p className="text-teal-100 text-sm">Financovatelné z OP JAK II</p>
      </div>
    </section>
  );
}
